<template>
    <!-- 首页点服务中心进入服务中心详情页 -->
    <div class='serviceCenter'>
        <div class="top-banner-box">
            <div class="top-banner-img" :style="{ backgroundImage: `url(${headerBgUrl})` }">
            </div>
        </div>
        <!-- 服务中心简介 -->
        <div class="overview">
            <div class="overview-con">
                <div class="overview-top">
                    <div class="overview-top-left">
                        <div class="pic" :style="{ backgroundImage: `url(${centerInfo.pic})` }"></div>
                    </div>
                    <div class="overview-top-right">
                        <div class="right-title">{{ centerInfo.title }}</div>
                        <div class="right-duty">
                            <div>{{ duty }}</div>
                            <div>{{ centerInfo.duty }}</div>
                        </div>
                        <div class="right-company">
                            <div>牵头单位：</div>
                            <div>{{ centerInfo.company }}</div>
                        </div>
                        <div class="right-companyList" style="margin-top: 60px;">
                            <div>{{ profile }}</div>
                            <div class="over-num-lines num4-lines">{{ centerInfo.description }}</div>
                            <!-- <div class="over-num-lines num3-lines">
                                <span v-for="(item, index) in centerInfo.companyList" :key="index">
                                    <span v-if="index < centerInfo.companyList.length - 1">{{ item.title + '、'
                                        }}</span>
                                    <span v-else>{{ item.title }}</span>
                                </span>
                            </div> -->
                        </div>
                    </div>
                </div>
                <div class="overview-bottom">
                    <div class="common-title">
                        成员单位
                    </div>
                    <div class="empty" v-if="!centerInfo['companyList']">暂无数据</div>
                    <div class="logoList">
                        <div class="logo" v-for="(item, index) in centerInfo.companyMiddleList" :key="index"
                            :style="{ backgroundImage: `url(${item.pic})` }">
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- 富文本 -->
        <div class="richText">
            <div class="common-title">
                中心介绍
            </div>
            <div class="richText-con">
                <div class="empty" v-if="!centerInfo.content">暂无数据</div>
                <div v-html="centerInfo.content"></div>
            </div>
        </div>
    </div>
</template>

<script>
import {
    serviceCenterDetail
} from "../../utils/interface";
export default {
    name: '',
    components: {},
    props: {},
    data() {
        return {
            headerBgUrl: require('../../assets/publicService/home/centerBg.png'),
            duty: '职       责：',
            profile: '简       介：',
            centerInfo: {
                pic: require('../../assets/publicService/empty.jpg'),
                title: '数字化服务中心',
                duty: '线上线下相结合，面向全区工业企业，围绕数字化转型提供诊断、咨询、解决方案、实施落地、培训交流等，助力企业提质降本增效、高质量发展。', // 职责
                company: '牵头单位111', // 牵头单位
                companyList: [
                    // { title: '公司一', pic: require('../../assets/publicService/home/centerBg.png') },
                    // { title: '公司二', pic: require('../../assets/publicService/home/centerBg.png') },
                    // { title: '公司三', pic: require('../../assets/publicService/home/centerBg.png') },
                    // { title: '公司四', pic: require('../../assets/publicService/home/centerBg.png') },
                    // { title: '公司五', pic: require('../../assets/publicService/home/centerBg.png') },
                    // { title: '公司六', pic: require('../../assets/publicService/home/centerBg.png') },
                    // { title: '公司六', pic: require('../../assets/publicService/home/centerBg.png') }
                ], // 成员单位
                content: '' // 富文本
            }
        };
    },
    watch: {},
    computed: {},
    created() { },
    mounted() {
        if (this.$route.query.uuid) {
            this.serviceCenterDetail(this.$route.query.uuid)
        }
    },
    methods: {
        // 服务中心详情信息
        serviceCenterDetail(uuid) {
            serviceCenterDetail(uuid).then(res => {
                if (res.success && Object.keys(res.data).length > 0) {
                    console.log('成功')
                    this.centerInfo = res.data
                    if (res.data.banner) {
                        this.headerBgUrl = res.data.banner
                    } else {
                        this.headerBgUrl = require('../../assets/publicService/home/centerBg.png')
                    }
                } else {
                    this.centerInfo = {
                        pic: require('../../assets/publicService/empty.jpg'),
                        title: '',
                        duty: '', // 职责
                        company: '', // 牵头单位
                        companyList: [], // 成员单位
                        content: '' // 富文本
                    }
                    this.headerBgUrl = require('../../assets/publicService/home/centerBg.png')
                }
            })
        }
    }
};
</script>
<style lang="less" scoped>
.serviceCenter {
    position: relative;
    margin-top: -80px;

    .empty {
        font-size: 24px;
        font-weight: 500;
        color: #5566779e;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
    }

    .common-title {
        font-size: 28px;
        font-weight: 600;
        color: #000;
        margin: 20px 0;
        text-align: center;
        position: relative;
    }

    .over-num-lines {
        word-break: break-all;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 1;
        overflow: hidden;
    }

    .num4-lines {
        -webkit-line-clamp: 4;
    }

    .top-banner-box {

        .top-banner-img {
            height: 500px;
            width: 100%;
            overflow: hidden;
            background-repeat: no-repeat;
            background-size: 100% 100%;
            display: flex;
            justify-content: center;
            align-items: center;
        }
    }

    .overview {
        min-height: 800px;
        background: url('../../assets/publicService/home/center.png') no-repeat center center /100% 100%;
        display: flex;
        align-items: center;

        &-con {
            width: 1300px;
            min-height: 700px;
            margin: 0 auto;
            background-color: #ffffff6b;
            // box-shadow: 0 0 6px #9999998a;
            border-radius: 16px;
            display: flex;
            flex-direction: column;
            align-items: center;

            .overview-top {
                width: 1240px;
                height: 350px;
                display: flex;
                flex-flow: row nowrap;
                justify-content: space-between;
                align-items: center;

                .overview-top-left {
                    width: 600px;
                    height: 100%;

                    .pic {
                        width: 615px;
                        height: 315px;
                        margin-top: 17px;
                        border-radius: 16px;
                        background: no-repeat center center / 100% 100%;
                    }
                }

                .overview-top-right {
                    width: 600px;
                    height: 100%;
                    box-sizing: border-box;
                    padding: 20px;

                    &>div {
                        margin-bottom: 20px;
                    }

                    .right-title,
                    .right-duty,
                    .right-company,
                    .right-companyList {
                        display: flex;

                        &>div {
                            min-width: 85px;
                            white-space: pre-wrap;
                        }
                    }

                    .right-title {
                        font-size: 28px;
                        font-weight: 600;
                    }

                    .right-duty {}

                    .right-company {}

                    .right-companyList {}
                }
            }

            .overview-bottom {
                flex: 1;
                width: 1250px;
                margin-bottom: 20px;
                position: relative;

                .logoList {
                    display: flex;
                    flex-flow: row wrap;
                    justify-content: center;
                    align-items: center;

                    .logo {
                        width: 208px;
                        height: 102px;
                        background: no-repeat center center/100% 92%;
                        // margin-bottom: 10px;
                        box-sizing: border-box;
                        // border: 1px solid #E0E0E0;
                        border-right: none;
                        margin: 2px 4px;
                    }
                }
            }
        }
    }

    .richText {
        position: relative;
        overflow: hidden;
        background-color: #F2F2F4;

        &-con {
            width: 1300px;
            margin: 0 auto;
            margin-bottom: 20px;
            min-height: 200px;
            display: flex;
            justify-content: center;
            border-radius: 16px;
            position: relative;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/newHome/serviceCenter.vue